import { render } from "./EditDescriptionComponentSummary.vue?vue&type=template&id=85fb955a"
import script from "./EditDescriptionComponentSummary.vue?vue&type=script&lang=js"
export * from "./EditDescriptionComponentSummary.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__